import { render, staticRenderFns } from "./new-bind.vue?vue&type=template&id=2935e097&scoped=true&"
import script from "./new-bind.vue?vue&type=script&lang=js&"
export * from "./new-bind.vue?vue&type=script&lang=js&"
import style0 from "./new-bind.vue?vue&type=style&index=0&id=2935e097&prod&lang=scss&"
import style1 from "./new-bind.vue?vue&type=style&index=1&id=2935e097&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2935e097",
  null
  
)

export default component.exports